import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaCirclePlus } from 'react-icons/fa6';


export default function Details(props) {
    const { title, detail, className } = props;

    return (
        <details className={classNames('group m-4', className)}>
            <summary className="rounded-xl bg-certego-gray pl-6 py-3 text-lg cursor-pointer text-certego-black flex flex-row gap-6 group-open:text-certego-darkgray">
                <div className="flex-none">
                    <FaCirclePlus className="text-4xl text-certego-white" />
                </div>
                <div className="grow self-center">
                    {title}
                </div>
            </summary>
            <div className="text-certego-darkgray mx-6 my-3">
                {detail}
            </div>
        </details>
    );
}

Details.defaultProps = {
    className: null,
};

Details.propTypes = {
    className: PropTypes.string,
    detail: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
};
